$(document).ready(function() {

    var $stickyContainer = $('div.sticky-submit');
    var $form = $('form.sticky-submitted');

    if ($form.length === 1 && $stickyContainer.length > 0)
    {
        var $button = $stickyContainer.find('button');

        $button.on('click', function(e) {
            // TODO: Confirm box with text
            if (!$button.prop('disabled'))
            {
                $button.prop('disabled', true);
                $button.find('i.fa').removeClass('fa-save').addClass('fa-refresh fa-spin');
                $form.submit();
            }
        });
    } else if ($form.length > 1)
    {
        console.log('Too many forms');
    }
});